export const ONE_HOUR = 3600000;

export const PRODUCT_ID_REGEX = /^((?!["']).)*$/;

export const EXTENDED_DESCRIPTION_DEFAULT = 'N/A';

export const DEFAULT_QUOTE_PDF_FOOTER_DISPLAY = 'Adding value to quality products';
export const RANKIN_QUOTE_PDF_FOOTER_DISPLAY = 'Delivering Automation Solutions';

export const CLIENT_ID = 'demo-pcq' as const;
export const QUOTES_KEY = 'quote' as const;
